module.exports = __webpack_public_path__ + "dc9e575a868c57ad602cbe677f65f427.pdf";